import { IJackpotDisplay } from "./IJackpotDisplay";
import { IJackpotDisplayFactory } from "./IJackpotDisplayFactory";
import { IJackpotDisplayResponsive } from "./IJackpotDisplayPIXIAPPResponsive";
import type { JackpotDisplayParams } from "./JackpotDisplayParams";
import { Settings, JackpotDisplayType } from "../Settings";


export class JackpotDisplayFactory implements IJackpotDisplayFactory {
    public async CreateNewJackpotDisplay(params: JackpotDisplayParams): Promise<IJackpotDisplay> {
        if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPot) {
            return new (await import("./JackpotDisplayDiamondPot")).JackpotDisplayDiamondPot(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz) {
            return new (await import("./JackpotDisplayOrtiz")).JackpotDisplayOrtiz(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot) {
            return new (await import("./JackpotDisplayPyramid")).JackpotDisplayPyramid(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.PreciousSpin) {
            return new (await import("./JackpotDisplayPrecSpin")).JackpotDisplayPrecSpin(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStep) {
            return new (await import("./JackpotDisplayDiamondPotStep")).JackpotDisplayDiamondPotStep(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotJubilee) {
            return new (await import("./JackpotDisplayJubilee")).JackpotDisplayJubilee(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotCaliente) {
            return new (await import("./JackpotDisplayCaliente")).JackpotDisplayCaliente(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPlayCity) {
            return new (await import("./JackpotDisplayDiamodPotPlayCity")).JackpotDisplayDiamodPotPlayCity(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JubileeLink) {
            if (Settings.Screens == 3) {
                return new (await import("./JackpotDisplayJubileeLink")).JackpotDisplayJubileeLink(params);
            }
            else if (Settings.Screens == 2) {
                return new (await import("./JackpotDisplayJubileeLink2")).JackpotDisplayJubileeLink2S(params);
            }
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.ViventoLink) {
            // if (Settings.Screens == 2){
            return new (await import("./JackpotDisplayViventoLink2")).JackpotDisplayViventoLink2S(params);
            //}
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay) {
            return new (await import("./JackpotDisplayPaytable")).JackpotDisplayPaytable(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPot) {
            return new (await import("./JackpotDisplayRappidDiamondPot")).JackpotDisplayRappidDiamondPot(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPot2) {
            return new (await import("./JackpotDisplayRappidDiamondPot")).JackpotDisplayRappidDiamondPot(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPotStep) {
            return new (await import("./JackpotDisplayRapidLinkDiamondPotStep")).JackpotDisplayRapidLinkDiamondPotStep(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPotFire) {
            return new (await import("./JackpotDisplayRapidLinkDiamondPotFire")).JackpotDisplayRapidLinkDiamondPotFire(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.PlayCityLink) {
            return new (await import("./JackpotDisplayPlayCityLink")).JackpotDisplayPlayCityLink(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFrames) {
            return new (await import("./JackpotDisplayDiamondPotRappidFrames")).JackpotDisplayDiamondPotRappidFrames(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepRappidFrames) {
            return new (await import("./JackpotDisplayDiamondPotStepRappidFrames")).JackpotDisplayDiamondPotStepRappidFrames(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RapidDiamondPotStep2) {
            return new (await import("./JackpotDisplayRapidLinkDiamondPotStep")).JackpotDisplayRapidLinkDiamondPotStep(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.RainbowGirls) {
            if (Settings.Screens == 3) {
                return new (await import("./JackpotDisplayRainbowGirls")).JackpotDisplayRainbowGirls(params);
            } else if (Settings.Screens == 2) {
                return new (await import("./JackpotDisplayRainbowGirlsStep")).JackpotDisplayRainbowGirlsStep(params);
            }
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared) {
            return new (await import("./JackpotDisplayDiamondPotStepShared")).JackpotDisplayDiamondPotStepShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepSharedSpineV2) {
            return new (await import("./JackpotDisplayDiamondPotStepSharedSpineV2")).JackpotDisplayDiamondPotStepSharedSpineV2(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepSinShared) {
            return new (await import("./JackpotDisplayDiamondPotStepSinShared")).JackpotDisplayDiamondPotStepSinShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepRappidFramesSpine) {
            return new (await import("./JackpotDisplayDiamondPotStepRappidFramesSpine")).JackpotDisplayDiamondPotStepRappidFramesSpine(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotRappidFramesSpine) {
            return new (await import("./JackpotDisplayDiamondPotRappidFramesSpine")).JackpotDisplayDiamondPotRappidFramesSpine(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared) {
            return new (await import("./JackpotDisplayDiamondPotPyramidShared")).JackpotDisplayDiamondPotPyramidShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared) {
            return new (await import("./JackpotDisplayDiamondPotPyramidSinShared")).JackpotDisplayDiamondPotPyramidSinShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared) {
            return new (await import("./JackpotDisplayDiamondPotPyramidJP4ShareJP3SinShared")).JackpotDisplayDiamondPotPyramidJP4ShareJP3SinShared(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S) {
            return new (await import("./JackpotDisplayDiamondPotPyramidShared2S")).JackpotDisplayDiamondPotPyramidShared2S(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared2S) {
            return new (await import("./JackpotDisplayDiamondPotPyramidSinShared2S")).JackpotDisplayDiamondPotPyramidSinShared2S(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S) {
            return new (await import("./JackpotDisplayDiamondPotPyramidJP4SharedJP3SinShared2S")).JackpotDisplayDiamondPotPyramidJP4SharedJP3SinShared2S(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.MysticPortalLink3S) {
            return new (await import("./JackpotDisplayMistycPortalLink")).JackpotDisplayMistycPortalLink3S(params);
        }
        else {
            throw "its not implemented"
        }
        return null;
    }

    public async CreateNewJackpotDisplayResponsive(params: JackpotDisplayParams): Promise<IJackpotDisplayResponsive> {
        if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotResponsivePIXI) {
            return new (await import("./JackpotDisplayDiamondPotResponsivePIXIAPP")).JackpotDisplayResponsivePIXIAPP(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.PlayCityLinkResponsivePIXI) {
            return new (await import("./JackpotDisplayPlayCityLinkResponsivePIXIAPP")).JackpotDisplayPlayCityLinkResponsivePIXIAPP(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JubileeLinkResponsivePIXI) {
            return new (await import("./JackpotDisplayJubileeLinkResponsivePIXIAPP")).JackpotDisplayJubileeLinkResponsivePIXIAPP(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotResponsivePIXIHorizontal) {
            return new (await import("./JackpotDisplayDiamondPotResponsivePIXIAPPHorizontal")).JackpotDisplayDiamondPotResponsivePIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinSharedResponsive) {
            return new (await import("./JackpotDisplayDiamondPotPyramidPIXIAPPHorizontal")).JackpotDisplayDiamondPotPyramidPIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JubileeLinkResponsivePIXIAPPHorizontal) {
            return new (await import("./JackpotDisplayJubileePIXIAPPHorizontal")).JackpotDisplayJubileePIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal) {
            return new (await import("./JackpotDisplayPlayCityPIXIAPPHorizontal")).JackpotDisplayPlayCityPIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.JackpotDisplayRapidLinkPIXIAPPHorizontal) {
            return new (await import("./JackpotDisplayRapidLinkResponsivePIXIAPPHorizontal")).JackpotDisplayRapidLinkResponsivePIXIAPPHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.MysticPortalLinkHorizontal) {
            return new (await import("./JackpotDisplayMistycPortalLinkHorizontal")).JackpotDisplayMysticPortalHorizontal(params);
        }
        else if (Settings.JackpotDisplayType == JackpotDisplayType.MysticPortalResponsive) {
            return new (await import("./JackpotDisplayPortalResponsiveSpine")).JackpotDisplayPortalResponsiveSpine(params);
        }
        else {
            throw new Error("JackpotDisplayFactory: JackpotDisplayType not implemented");
        }
    }
    /* This was made to create the JackpotDispaly for one screen and to work with jubile link*/
    public async CreateNewJackpotDisplay1Screen(params: JackpotDisplayParams): Promise<IJackpotDisplay> {
        if (Settings.JackpotDisplayType == JackpotDisplayType.DragonJackpot) {
            return new (await import("./JackpotDisplay1Screen")).JackpotDisplay1screen(params);
        } else if (Settings.JackpotDisplayType == JackpotDisplayType.JubileeLink) {
            return new (await import("./JackpotDisplayJubileeLink1Screen")).JackpotDisplayJubileeLink1Screen(params);
        }
        else {
            throw "It's not implemented"
        }
        return null;
    }
}
